const img = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}&auto=format`;

export const IMG = {
  heroTower: img("photo-1766350060749-25e536fb1c3a", 2400),
  goldFacade: img("photo-1764344815476-9aba046ebe97", 1800),
  towerNight: img("photo-1781453861998-409dc1e6feca", 1600),
  buildingWindows: img("photo-1764536601672-80b15920d5c3", 1600),
  architectureDark: img("photo-1635074155443-6cbf74711dd2", 1800),
  boardroom:
    "https://images.pexels.com/photos/7433919/pexels-photo-7433919.jpeg?auto=compress&cs=tinysrgb&w=1600",
  boardroomWarm: img("photo-1573167627769-e201a7ddf409", 1600),
  facadeNight:
    "https://images.pexels.com/photos/13762563/pexels-photo-13762563.jpeg?auto=compress&cs=tinysrgb&w=1600",
  cinemaLuxury:
    "https://images.pexels.com/photos/18501410/pexels-photo-18501410.jpeg?auto=compress&cs=tinysrgb&w=1600",
  residentialDusk: img("photo-1545324418-cc1a3fa10c00", 2000),
  residentialTower: img("photo-1460317442991-0ec209397118", 1600),
  cityResidential:
    "https://images.pexels.com/photos/20635888/pexels-photo-20635888.jpeg?auto=compress&cs=tinysrgb&w=1600",
  glassFacade:
    "https://images.pexels.com/photos/10349473/pexels-photo-10349473.jpeg?auto=compress&cs=tinysrgb&w=1600",
  singerGold: img("photo-1576064535163-095bccc642b2", 1600),
  domeStage: img("photo-1589553975453-d7e36c7cfbf8", 1600),
  laserStage: img("photo-1709731191876-899e32264420", 1600),
  crowdLights: img("photo-1770737639812-bd3c709da73b", 1600),
  stageArena: img("photo-1521399252503-e25b03aeda66", 1600),
  concertCrowd:
    "https://images.pexels.com/photos/38780318/pexels-photo-38780318.jpeg?auto=compress&cs=tinysrgb&w=1600",
  poolDusk: img("photo-1571896349842-33c89424de2d", 1600),
  resortSea: img("photo-1571003123894-1f0594d2b5d9", 1600),
  villaNight: img("photo-1707189856923-46dd41ea2bdc", 1600),
  hotelBlue: img("photo-1542314831-068cd1dbfeeb", 1600),
  filmCrew: img("photo-1632187981988-40f3cbaeef5e", 1600),
  soundstage: img("photo-1612544409025-e1f6a56c1152", 1600),
  clapperboard: img("photo-1515634928627-2a4e0dae3ddf", 1600),
  cameraRig:
    "https://images.pexels.com/photos/1117132/pexels-photo-1117132.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const services = [
  {
    "slug": "business-strategy",
    "azSlug": "biznes-strategiyasi",
    "index": "01",
    "name": "Business Strategy & Architecture",
    "short": "We define direction, priorities and the growth model, then build the business structure to support them.",
    "tagline": "We define direction, priorities and the growth model, then build the business structure to support them.",
    "heroImg": "https://images.unsplash.com/photo-1635074155443-6cbf74711dd2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800&auto=format",
    "overview": "We work with leadership teams to define where the business plays, how it wins, and what has to be true across strategy, structure and capability. The output is not a deck that ages in a drawer — it is a decision system the board can act on next quarter and the one after.",
    "subs": [
      {
        "t": "Market & Competitive Intelligence",
        "d": "A clear read on your market, rivals and white space — mapped to decisions, not trivia."
      },
      {
        "t": "Growth & Expansion Strategy",
        "d": "Where to grow next: new sectors, geographies, or offerings, sequenced by return and readiness."
      },
      {
        "t": "Business Model Design",
        "d": "Rework how value is created and captured — from one-off delivery to recurring, scalable revenue."
      },
      {
        "t": "Operating Model & Organisation",
        "d": "Structure, roles and governance aligned to the strategy, so execution doesn't rely on heroics."
      },
      {
        "t": "Board & Investor Narratives",
        "d": "The strategy story told with the rigour boards, lenders and investors expect."
      },
      {
        "t": "Transformation Roadmaps",
        "d": "A sequenced plan with owners, milestones and metrics — from ambition to operating rhythm."
      }
    ],
    "outcomes": [
      "A leadership team aligned on one direction and the trade-offs behind it.",
      "Growth decisions made on evidence, not instinct or inherited assumptions.",
      "A roadmap that survives contact with the operating calendar."
    ],
    "deliverables": [
      "Situation & diagnostic report",
      "Growth thesis and strategic options",
      "Business model and operating model blueprint",
      "Transformation roadmap with milestones",
      "Board / investor narrative pack",
      "Quarterly strategy review cadence"
    ],
    "steps": [
      {
        "t": "Diagnostic",
        "d": "Interviews, data review and market analysis to locate the real constraint."
      },
      {
        "t": "Architecture",
        "d": "Options, trade-offs and a chosen direction with clear logic."
      },
      {
        "t": "Activation",
        "d": "Roadmap, owners and review rhythm — embedded with your team."
      }
    ],
    "problem": "Growth without clear priorities fragments decisions and resources.",
    "commercialImpact": "A lack of direction can spread investment too thin and slow execution.",
    "measures": "Priority delivery, decision speed and progress against the agreed growth plan.",
    "relatedCase": "baki-evleri"
  },
  {
    "slug": "brand-strategy",
    "azSlug": "brend-strategiyasi",
    "index": "02",
    "name": "Brand Strategy",
    "short": "We turn business value into a position the market understands, remembers and values more highly.",
    "tagline": "We turn business value into a position the market understands, remembers and values more highly.",
    "heroImg": "https://images.unsplash.com/photo-1764344815476-9aba046ebe97?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800&auto=format",
    "overview": "Brand is not decoration — it is the commercial asset that decides whether buyers perceive you as a commodity or a category leader. We define the positioning, architecture and identity direction that make premium pricing defensible, then direct the identity work to match.",
    "subs": [
      {
        "t": "Positioning & Differentiation",
        "d": "A defensible position your competitors can't copy and your buyers actually value."
      },
      {
        "t": "Brand Architecture",
        "d": "How the house, sub-brands and offers relate — built for today's portfolio, ready for the next one."
      },
      {
        "t": "Verbal Identity & Messaging",
        "d": "Language, narrative and proof points that carry the position across every touchpoint."
      },
      {
        "t": "Identity Art Direction",
        "d": "Creative direction for visual identity, delivered with our production partners."
      },
      {
        "t": "Internal Brand & Culture",
        "d": "The brand employees can retell — because they live it before customers see it."
      },
      {
        "t": "Rebrand Programmes",
        "d": "Managed repositioning for acquisitions, mergers and step-change growth."
      }
    ],
    "outcomes": [
      "Premium pricing justified by perception, not negotiation.",
      "One brand system instead of a patchwork of decks, sites and brochures.",
      "Internal teams who can retell the brand without a copywriter present."
    ],
    "deliverables": [
      "Brand positioning and platform",
      "Brand architecture map",
      "Messaging framework and narrative",
      "Visual & verbal identity direction",
      "Brand guidelines and asset system",
      "Internal launch and enablement kit"
    ],
    "steps": [
      {
        "t": "Discovery",
        "d": "Stakeholder, customer and market research to find the credible position."
      },
      {
        "t": "Definition",
        "d": "Positioning, architecture and narrative chosen and pressure-tested."
      },
      {
        "t": "Direction",
        "d": "Identity art direction and guidelines, produced with our partners."
      }
    ],
    "problem": "The quality of the business is not reflected in how the market values it.",
    "commercialImpact": "Weak differentiation makes premium pricing harder to sustain.",
    "measures": "Price acceptance, qualified demand and consistency of brand recognition.",
    "relatedCase": "baki-evleri"
  },
  {
    "slug": "marketing-strategy",
    "azSlug": "marketinq-strategiyasi",
    "index": "03",
    "name": "Marketing & Demand Systems",
    "short": "We turn marketing from a list of activities into a system that creates sustained demand and measurable results.",
    "tagline": "We turn marketing from a list of activities into a system that creates sustained demand and measurable results.",
    "heroImg": "https://images.unsplash.com/photo-1521399252503-e25b03aeda66?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "overview": "Marketing that reports to revenue. We design the go-to-market plan, channel system and content engine that put qualified demand in front of your sales team — then instrument it so every major bet has a number attached.",
    "subs": [
      {
        "t": "Go-to-Market Strategy",
        "d": "Launch and expansion plans with audiences, offers, channels and sequencing decided up front."
      },
      {
        "t": "Demand Generation",
        "d": "Always-on programmes that create qualified pipeline, not just impressions."
      },
      {
        "t": "Channel & Media Strategy",
        "d": "Budgets and channel mix allocated by return, reviewed quarterly."
      },
      {
        "t": "Content & Editorial Systems",
        "d": "A repeatable editorial engine that builds authority while you sleep."
      },
      {
        "t": "Campaign Direction",
        "d": "Creative and campaign direction for flagship launches, produced with our partners."
      },
      {
        "t": "Lifecycle & CRM",
        "d": "Onboarding, nurture and win-back journeys mapped to how buyers actually decide."
      }
    ],
    "outcomes": [
      "Pipeline with a source, a cost and a conversion story — not a mystery.",
      "Marketing spend concentrated on channels that compound.",
      "A content engine the team can run without founder involvement."
    ],
    "deliverables": [
      "Go-to-market plan",
      "Channel & budget allocation model",
      "Demand generation blueprint",
      "Content strategy and editorial calendar",
      "Campaign concepts and briefs",
      "Marketing dashboard and KPI set"
    ],
    "steps": [
      {
        "t": "Audit",
        "d": "Funnel, channel and content audit to find where demand leaks."
      },
      {
        "t": "Blueprint",
        "d": "GTM plan, channel mix and offer strategy for the next 12 months."
      },
      {
        "t": "Launch",
        "d": "Campaigns and content shipped with our production partners — measured weekly."
      }
    ],
    "problem": "Campaign activity does not create a predictable flow of qualified enquiries.",
    "commercialImpact": "Unstable demand makes sales planning and resource allocation harder.",
    "measures": "Qualified enquiries, cost per qualified enquiry and conversion to sales opportunities.",
    "relatedCase": "art-tower"
  },
  {
    "slug": "sales-commercial-systems",
    "azSlug": "satis-sistemleri",
    "index": "04",
    "name": "Sales & Commercial Systems",
    "short": "We connect enquiries, pricing, negotiation and the sales process in one revenue system.",
    "tagline": "We connect enquiries, pricing, negotiation and the sales process in one revenue system.",
    "heroImg": "https://images.unsplash.com/photo-1573167627769-e201a7ddf409?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "overview": "We turn founder-led, relationship-driven selling into a commercial system: clear pricing architecture, documented playbooks, a pipeline that forecasts honestly and a CRM that tells the truth. The goal is a business where revenue is produced by design.",
    "subs": [
      {
        "t": "Commercial Architecture & Pricing",
        "d": "Offer tiers, pricing logic and margin structure that fund the growth plan."
      },
      {
        "t": "Sales Playbooks & Enablement",
        "d": "Scripts, objection handling and sequences your team will actually use."
      },
      {
        "t": "Pipeline & Funnel Design",
        "d": "Stages, exit criteria and conversion maths that make forecasting possible."
      },
      {
        "t": "CRM & Revenue Tech",
        "d": "Tooling selected, configured and adopted — dashboards, not spreadsheets."
      },
      {
        "t": "Proposal & Bid Systems",
        "d": "Repeatable proposal machinery that raises win rates on serious deals."
      },
      {
        "t": "Partner & Channel Sales",
        "d": "Referral, reseller and alliance channels structured and incentivised."
      }
    ],
    "outcomes": [
      "A pipeline leadership can forecast and investors can trust.",
      "Pricing power protected by structure, not charisma.",
      "Sales onboarding measured in weeks, not quarters."
    ],
    "deliverables": [
      "Commercial architecture & pricing model",
      "Sales playbook and enablement kit",
      "Pipeline design and CRM configuration",
      "Proposal / bid template system",
      "Revenue dashboard and KPI definitions",
      "Partner channel plan"
    ],
    "steps": [
      {
        "t": "Map",
        "d": "Current revenue engine audited deal-by-deal for leaks and friction."
      },
      {
        "t": "Design",
        "d": "Pricing, pipeline and playbook built around how your buyers decide."
      },
      {
        "t": "Operate",
        "d": "Systems configured, team trained, reviews installed."
      }
    ],
    "problem": "Enquiries arrive, but follow-up, offers and negotiations do not work as one process.",
    "commercialImpact": "Lost opportunities reduce revenue and waste the cost of acquiring demand.",
    "measures": "Enquiry-to-contract conversion, sales cycle and revenue by source.",
    "relatedCase": "baki-evleri"
  },
  {
    "slug": "creative-strategy-content",
    "azSlug": "kreativ-strategiya",
    "index": "05",
    "name": "Creative Strategy & Content",
    "short": "We build creative systems that carry the strategy and influence decisions, as well as looking right.",
    "tagline": "We build creative systems that carry the strategy and influence decisions, as well as looking right.",
    "heroImg": "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "overview": "We direct the creative: the concepts, campaigns, films and photography that make a strategy felt, not just understood. YUXEL sets the direction, standards and story — our vetted production partners deliver video, photo, editing and motion design to that brief.",
    "subs": [
      {
        "t": "Creative Direction",
        "d": "A creative platform that translates strategy into art direction, tone and world."
      },
      {
        "t": "Campaign Concepts",
        "d": "Big ideas with the production plan and channel cut-downs designed in."
      },
      {
        "t": "Film & Photography Direction",
        "d": "Treatment, shot direction and on-set creative control via our production partners."
      },
      {
        "t": "Editorial & Thought Leadership",
        "d": "Opinion, insight and story content that builds authority in your category."
      },
      {
        "t": "Motion & Brand Systems",
        "d": "Motion identity, templates and brand-in-motion systems for every channel."
      },
      {
        "t": "Production Oversight",
        "d": "Briefing, budgeting and quality control of partner-delivered production."
      }
    ],
    "outcomes": [
      "Creative that is unmistakably yours — and impossible to unsee.",
      "A content library that compounds, not a feed that resets to zero.",
      "One accountable direction across every asset and vendor."
    ],
    "deliverables": [
      "Creative platform and art direction",
      "Campaign concept & production briefs",
      "Film / photo treatments and shot lists",
      "Editorial strategy and content calendar",
      "Motion & template system",
      "Production partner briefs and QC"
    ],
    "steps": [
      {
        "t": "Platform",
        "d": "Creative strategy and art direction defined against the brand strategy."
      },
      {
        "t": "Direction",
        "d": "Treatments, briefs and storyboards for every flagship asset."
      },
      {
        "t": "Oversight",
        "d": "Partners produce; YUXEL directs, reviews and approves."
      }
    ],
    "problem": "Content is produced without a clear strategic role in the customer’s decision.",
    "commercialImpact": "Inconsistent communication can weaken recognition and reduce campaign effectiveness.",
    "measures": "Content contribution to qualified demand and customer progression.",
    "relatedCase": "baki-evleri"
  },
  {
    "slug": "product-offer-strategy",
    "azSlug": "mehsul-ve-teklif-strategiyasi",
    "index": "06",
    "name": "Product & Offer Architecture",
    "short": "We align products, packages and offers with how customers decide and how the business earns its margin.",
    "tagline": "We align products, packages and offers with how customers decide and how the business earns its margin.",
    "heroImg": "https://images.unsplash.com/photo-1764536601672-80b15920d5c3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "overview": "Most businesses sell everything and stand for nothing. We architect your offers — what is packaged, how it is tiered, what it promises and what it costs — so the market can say yes faster and your margin survives the conversation.",
    "subs": [
      {
        "t": "Offer Architecture",
        "d": "The complete offer map: cores, add-ons, entry points and premium tiers."
      },
      {
        "t": "Productisation of Services",
        "d": "Turning bespoke delivery into named, repeatable, sellable products."
      },
      {
        "t": "Packaging & Tiering",
        "d": "Good-better-best structures that lift average deal size without new customers."
      },
      {
        "t": "Launch Strategy",
        "d": "New offers taken to market with proof, pricing and a dated plan."
      },
      {
        "t": "Pricing Experiments",
        "d": "Structured tests that find the price the market will happily pay."
      },
      {
        "t": "Portfolio Roadmaps",
        "d": "What to launch, retire and protect over the next 24 months."
      }
    ],
    "outcomes": [
      "Higher average deal value from structure, not discounting.",
      "Buyers who self-qualify because the offer does the sorting.",
      "A portfolio with a plan, not a price list with a history."
    ],
    "deliverables": [
      "Offer architecture and naming system",
      "Productised service definitions",
      "Tiering and pricing model",
      "Launch plan and sales narrative",
      "Offer one-pagers and sales collateral",
      "Portfolio roadmap"
    ],
    "steps": [
      {
        "t": "Deconstruct",
        "d": "Every current offer mapped by margin, delivery cost and demand."
      },
      {
        "t": "Architect",
        "d": "New offer structure, tiers and pricing built and tested."
      },
      {
        "t": "Launch",
        "d": "Narrative, collateral and rollout with the sales team."
      }
    ],
    "problem": "Customers cannot see why they should choose this product or package.",
    "commercialImpact": "An unclear offer increases price pressure and can weaken margin.",
    "measures": "Offer acceptance, package mix and contribution margin.",
    "relatedCase": "baki-evleri"
  },
  {
    "slug": "business-analytics",
    "azSlug": "biznes-analitikasi",
    "index": "07",
    "name": "Business Analytics",
    "short": "We build the metrics, reporting and decision processes that reveal which activities create results.",
    "tagline": "We build the metrics, reporting and decision processes that reveal which activities create results.",
    "heroImg": "https://images.pexels.com/photos/10349473/pexels-photo-10349473.jpeg?auto=compress&cs=tinysrgb&w=1600",
    "overview": "We build the measurement layer of the business: the KPI architecture, dashboards and research that turn scattered reporting into a weekly decision rhythm. When the numbers are right, the right conversation happens — and it happens faster.",
    "subs": [
      {
        "t": "KPI & Metric Architecture",
        "d": "A metric tree that connects daily activity to the outcomes the board cares about."
      },
      {
        "t": "Executive Dashboards",
        "d": "One screen of truth for leadership — live, trusted and argued over."
      },
      {
        "t": "Market & Customer Research",
        "d": "Interviews, surveys and analysis that replace assumption with evidence."
      },
      {
        "t": "Attribution & Funnel Analytics",
        "d": "Where demand comes from, where it dies, and what it costs."
      },
      {
        "t": "Forecasting & Scenario Models",
        "d": "Revenue and capacity models for planning, hiring and investment cases."
      },
      {
        "t": "Data Storytelling",
        "d": "Findings delivered as decisions, not exports."
      }
    ],
    "outcomes": [
      "One version of the numbers across the leadership team.",
      "Weekly decisions made on live data instead of last quarter's memory.",
      "Investment cases backed by evidence a lender or investor accepts."
    ],
    "deliverables": [
      "KPI architecture and definitions",
      "Executive dashboard build",
      "Customer & market research report",
      "Funnel and attribution analysis",
      "Forecast / scenario model",
      "Decision review cadence"
    ],
    "steps": [
      {
        "t": "Instrument",
        "d": "Data sources audited, KPI tree defined, gaps named."
      },
      {
        "t": "Build",
        "d": "Dashboards and models shipped into the tools you already run."
      },
      {
        "t": "Embed",
        "d": "Review rhythm installed with the leadership team."
      }
    ],
    "problem": "Teams cannot see which activities contribute to commercial results.",
    "commercialImpact": "Decisions made without reliable evidence can misdirect budgets and priorities.",
    "measures": "Data completeness, reporting accuracy and time to make a decision.",
    "relatedCase": null
  },
  {
    "slug": "ai-business-systemization",
    "azSlug": "ai-biznes",
    "index": "08",
    "name": "AI & Business Systemisation",
    "short": "We apply AI where it can meaningfully improve time, cost and decision quality.",
    "tagline": "We apply AI where it can meaningfully improve time, cost and decision quality.",
    "heroImg": "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format",
    "overview": "We map where AI genuinely creates leverage in your operating model, then systemise the workflows around it: documented processes, automated handoffs, knowledge systems and team adoption. No hype cycles — just measurable hours returned and quality made consistent.",
    "subs": [
      {
        "t": "AI Opportunity Audit",
        "d": "A ranked map of where AI returns real hours and margin in your business."
      },
      {
        "t": "Workflow Automation",
        "d": "High-volume workflows redesigned and automated end to end."
      },
      {
        "t": "Knowledge & SOP Systems",
        "d": "Institutional know-how captured, structured and retrievable."
      },
      {
        "t": "Custom AI Tooling Direction",
        "d": "Spec and delivery oversight for internal tools built on proven AI platforms."
      },
      {
        "t": "Team Adoption & Training",
        "d": "Enablement that turns tools into habits and habits into hours saved."
      },
      {
        "t": "Governance & Quality Control",
        "d": "Guardrails, review steps and quality thresholds that keep output safe."
      }
    ],
    "outcomes": [
      "Hours returned every week from the workflows that drain your team.",
      "A business that runs on documented systems, not personal memory.",
      "AI adoption that sticks past the first pilot."
    ],
    "deliverables": [
      "AI opportunity map with business case",
      "Workflow automation designs",
      "Knowledge base / SOP system",
      "Tool specs and delivery oversight",
      "Team training programme",
      "Governance & QC framework"
    ],
    "steps": [
      {
        "t": "Audit",
        "d": "Operations walked through hour by hour to find leverage."
      },
      {
        "t": "Systemise",
        "d": "Workflows documented, automated and piloted with your team."
      },
      {
        "t": "Scale",
        "d": "What worked, scaled; what didn't, retired — then trained in."
      }
    ],
    "problem": "Repetitive processes and undocumented knowledge depend on individual employees.",
    "commercialImpact": "Manual work consumes time and makes quality harder to maintain as the business grows.",
    "measures": "Time saved, process error rate and cost per completed task.",
    "relatedCase": null
  }
];
export const getService = slug => services.find(s=>s.slug===slug || s.azSlug===slug);
